import { Injectable } from "@angular/core";
import { ApiService } from "@api/services/api.service";
import { ICenter } from "@shared/models/center";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CentersDataService {
    constructor(private readonly apiService: ApiService) {}

    public getHealthCenters(): Observable<ICenter[]> {
        const endpoint = "api/centers"
        return this.apiService.get<ICenter[]>(endpoint);
    }
}